/**
 * useEquipmentTypeWebshop — STORY-1306 slice C (type-editor webshop-tab).
 * A webshop-fragment betöltése + PATCH-mentés a pinnelt #407-kontraktusra.
 */

import {
  getEquipmentTypeWebshop,
  patchEquipmentTypeWebshop,
  type EquipmentTypeWebshopPatch,
  type EquipmentTypeWebshopRead,
} from '@/api/equipment-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useEquipmentTypeWebshop(typeId: string | null): {
  data: EquipmentTypeWebshopRead | undefined;
  isLoading: boolean;
  isError: boolean;
  save: (patch: EquipmentTypeWebshopPatch) => Promise<EquipmentTypeWebshopRead>;
  isSaving: boolean;
} {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ['equipment-types', typeId, 'webshop'],
    queryFn: () => getEquipmentTypeWebshop(typeId as string),
    enabled: typeId !== null && typeId.length > 0,
  });
  const mutation = useMutation({
    mutationFn: (patch: EquipmentTypeWebshopPatch) =>
      patchEquipmentTypeWebshop(typeId as string, patch),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['equipment-types'] });
    },
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    save: mutation.mutateAsync,
    isSaving: mutation.isPending,
  };
}
